import e from"styled-components";const o=e.textarea`
	padding: 4px 8px;
	background-color: ${({theme:e})=>e.bg.primary};
	border-radius: 8px;
	box-sizing: border-box;
	border: none;
	width: 100%;
	resize: vertical;

	&:focus {
		outline: ${({theme:e})=>`2px solid ${e.text.brand}4d`};
		outline-offset: 1px;
		background-color: ${({theme:e})=>e.bg.general};
	}
`;export{o as TextAreaContainer};
